'use client';

import { useTranslation } from '@/context/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faGraduationCap, 
  faFlask, 
  faHandsHelping, 
  faGlobe,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import { siteConfig } from '@/config/site';

export default function GlobalFocusSection() {
  const { language } = useTranslation();
  const siteName = siteConfig.name || "UNMUL";

  const focusAreas = [
    {
      id: 1,
      titleId: 'Pendidikan Berkualitas',
      titleEn: 'Quality Education',
      descId: 'Menyelenggarakan pendidikan unggul berbasis standar internasional untuk menghasilkan lulusan yang kompeten dan berkarakter.',
      descEn: 'Providing excellent education based on international standards to produce competent and character-driven graduates.',
      icon: faGraduationCap,
      color: 'bg-blue-500',
      delay: 0
    },
    {
      id: 2,
      titleId: 'Riset & Inovasi',
      titleEn: 'Research & Innovation',
      descId: 'Mengembangkan riset inovatif yang relevan dengan kebutuhan masyarakat dan tantangan global.',
      descEn: 'Developing innovative research relevant to community needs and global challenges.',
      icon: faFlask,
      color: 'bg-green-500',
      delay: 100
    },
    {
      id: 3,
      titleId: 'Pengabdian Masyarakat',
      titleEn: 'Community Service',
      descId: 'Menerapkan ilmu pengetahuan dan teknologi untuk pemberdayaan dan kesejahteraan masyarakat.',
      descEn: 'Applying science and technology for community empowerment and well-being.',
      icon: faHandsHelping,
      color: 'bg-yellow-500',
      delay: 200
    },
    {
      id: 4,
      titleId: 'Jejaring Global',
      titleEn: 'Global Network',
      descId: 'Memperluas kemitraan strategis dengan institusi di seluruh dunia untuk kolaborasi akademik dan riset.',
      descEn: 'Expanding strategic partnerships with institutions worldwide for academic and research collaboration.',
      icon: faGlobe,
      color: 'bg-purple-500',
      delay: 300
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16" data-aos="fade-up">
          <span className="inline-block bg-unmulGreen text-white px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            {language === 'en' ? 'Our Focus' : 'Fokus Utama'}
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-800 mb-6">
            {language === 'en' ? 'Core Areas of Excellence' : 'Fokus & Keunggulan Kami'}
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            {language === 'en' 
              ? `${siteName} is committed to excellence in these key areas to support the main university mission.` 
              : `${siteName} berkomitmen pada keunggulan di bidang-bidang utama ini untuk mendukung misi utama institusi.`}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {focusAreas.map((area) => (
            <div 
              key={area.id}
              className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group"
              data-aos="fade-up"
              data-aos-delay={area.delay}
            >
              <div className={`w-14 h-14 ${area.color} rounded-xl flex items-center justify-center text-white text-2xl mb-6 shadow-md group-hover:scale-110 transition-transform`}>
                <FontAwesomeIcon icon={area.icon} />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-unmulGreen transition-colors">
                {language === 'en' ? area.titleEn : area.titleId}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                {language === 'en' ? area.descEn : area.descId}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
